import React, { Component } from "react";
import { isMobile } from "../../../utils/util";
import "./SideMenu.css";

class SideMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  componentDidMount() {
    this.openMenu();
  }

  componentWillUnmount() {
    // document.getElementById("container-children").classList.remove("side-menu-expanded");
  }

  openMenu = () => {
    const touchsupport = isMobile(navigator.userAgent);

    if (
      !touchsupport &&
      (window.location.pathname.includes("/hair/profile") ||
        window.location.pathname.includes("/hair/recommendations"))
    ) {
      if (localStorage.getItem("first_from_onboarding"))
        localStorage.removeItem("first_from_onboarding");
      setTimeout(() => {
        this.handleOpen();
      }, 3000);
    }
  };

  handleOpen = () => {
    let content = document.getElementById("container-children");
    this.setState({ open: true });
    // content.classList.add("side-menu-expanded");
  };

  handleClose = () => {
    let content = document.getElementById("container-children");
    this.setState({ open: false });
    // content.classList.remove("side-menu-expanded");
  };

  render() {
    return (
      <div
        className={
          this.state.open ? "side-menu side-menu__expanded" : "side-menu"
        }
      >
        <div className="side-menu__links-container">
          <ul className="side-menu__links">
            {/* <li
              className={
                window.location.pathname.includes("/hair/")
                  ? "side-menu__link side-menu__link--active"
                  : "side-menu__link"
              }
            >
              <a
                className="side-menu__links__hair-link"
                onClick={e => {
                  if (!localStorage.getItem("user_has_hair_profile")) {
                    e.preventDefault();
                    this.props.renderHairPopup(true);
                  }
                }}
                href="/hair/profile"
              >
                My Hair
              </a>
            </li> */}
            <li
              className={
                !window.location.pathname.includes("/hair/") &&
                !window.location.pathname.includes("/ath/") &&
                (window.location.pathname.includes("/survey-result") ||
                  window.location.pathname.includes("/recommendations"))
                  ? "side-menu__link side-menu__link--active"
                  : "side-menu__link"
              }
            >
              <a
                onClick={e => {
                  if (!localStorage.getItem("user_has_skin_profile")) {
                    e.preventDefault();
                    this.props.renderHairPopup(false);
                  }
                }}
                href="/survey-result"
              >
                My Skin
              </a>
            </li>
          </ul>
        </div>
        <div onClick={this.handleClose} className="side-menu__deexpand-buton">
          <div className="side-menu__deexpand-arrow" />
        </div>
        {!this.state.open ? (
          <div onClick={this.handleOpen} className="side-menu__open-button">
            <div className="side-menu__expand-arrow" />
          </div>
        ) : null}
      </div>
    );
  }
}
export default SideMenu;



// WEBPACK FOOTER //
// ./src/components/hair/sidemenu/SideMenu.js